export default __webpack_public_path__ + "static/media/Group37586.4554f638.png";